<template>
    <div class="d-flex justify-content-between">
        <div>
            <button v-if="add" @click="addPerson" class="btn btn-primary">+ ADD PERSON</button>
            
            <button v-if="move" @click="movePersons" class="btn btn-primary">MOVE</button>
        </div>
        <div>
            <button v-if="del" @click.prevent="deletePersonCheck" class="btn btn-border">DELETE</button>
        </div>
    </div>
</template>


<script>
import {bus} from '../../bus';
import axios from 'axios';
import Dotscontrol from '../Dotscontrol';
import iconsort from "../iconsort";
import PersonsList from './PersonsList.vue';
export default {
    props: {
        add: Boolean,
        move: Boolean,
        del: Boolean,
        category_id: Number
    },
    data(){
        return{
            data: {},
            listdelete: []
        }
    },
    methods: {     
        movePersons(){
            bus.$emit('openpopup', {
                'title_form': 'Move persons',
                'open': true,
                'type': 'moveperson',                
                'personsIds': this.personsIds
            });
        },
        addPerson(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formperson',
                'crud': 'create',
                'title_form': 'Add person to '+ this.title_person,
                'category_id': Number(this.category_id),
                'person': {
                    "first_name": "",
                    "last_name": "",
                    "email": "",
                    "info": "",
                    "link": "",
                    "category_id": Number(this.category_id),
                    "faces": []
                }
            });
        },
        deletePerson(id){
            // alert(id);
            return axios.delete('/persons/'+id).then((responce) => {
                console.log(responce);
                return responce;
            }).catch((error) => {
                console.log('error delete person', error);
                throw error;
            });
        },                     
        async deletePersonCheck(){
            
            console.log('fire delete person check, this.listdelete from control component: ', this.listdelete);
            
            const ids = (this.listdelete || []).slice();
            this.listdelete = [];
            this.personsIds = [];
            if (!ids.length) {
                return;
            }
            // Sequential deletes: concurrent Promise.all raced Faces
            // compact/soft-delete and left orphan face_ids that then 502'd.
            // Never swallow failures — surface which ids remain.
            const failed = [];
            for (const id of ids) {
                try {
                    await this.deletePerson(id);
                } catch (error) {
                    const data = (error && error.response && error.response.data) || {};
                    const detail = data.detail || data.message || (error && error.message) || 'unknown';
                    failed.push({ id, detail });
                    console.error('bulk delete failed for', id, detail);
                }
            }
            bus.$emit('getListPerson');
            if (failed.length) {
                const lines = failed.map((f) => {
                    const d = typeof f.detail === 'object' ? JSON.stringify(f.detail) : String(f.detail);
                    return `${f.id}: ${d}`;
                });
                alert(`Failed to delete ${failed.length} of ${ids.length} person(s):\n${lines.join('\n')}`);
            }
        }
    },
    mounted(){
        bus.$on('changeSelectPersons', (data) => {
            if(data){
                this.listdelete = data.listdelete;
                this.personsIds = data.personsIds;
                console.log('this.personsIds from control: ', this.personsIds);
                console.log('this.listdelete from control: ', this.listdelete);
            }
        })
        console.log('this.add when call from categories: ', this.add);
    },
    components: {      
        Dotscontrol,
        iconsort,
        PersonsList
    }, 
    watch: {
    },
}
</script>

<style scoped>
    .pagination {
     flex-wrap: wrap;   
    }
    
    .table-list .table-list-row {
        grid-template-columns: 5fr 100px 3fr 205px;
    }
    .table-list-row__description {
        padding: 0 5px;
    }
</style>
